module.exports = __webpack_public_path__ + "img/Tibet.3d868379.svg";